import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { AuthProvider } from "@/contexts/AuthContext";
import { RoleProvider } from "@/contexts/RoleContext";
import { SimulationProvider } from "@/contexts/SimulationContext";
import { AVRDrawerProvider } from "@/contexts/AVRDrawerContext";
import { AskNiqProvider } from "@/contexts/AskNiqContext";
import { AppShell } from "@/components/layout/AppShell";
import { RequireAuth } from "@/components/RequireAuth";

import Dashboard from "@/pages/Dashboard";
import Mimic from "@/pages/Mimic";
import Twins from "@/pages/Twins";
import TwinDetail from "@/pages/TwinDetail";
import Energy from "@/pages/Energy";
import YieldPage from "@/pages/YieldPage";
import Safety from "@/pages/Safety";
import Carbon from "@/pages/Carbon";
import Opportunities from "@/pages/Opportunities";
import Actions from "@/pages/Actions";
import Quality from "@/pages/Quality";
import Simulation from "@/pages/Simulation";
import Ontology from "@/pages/Ontology";
import Tags from "@/pages/Tags";
import TagDetail from "@/pages/TagDetail";
import AskNiqFullPage from "@/pages/AskNiqFullPage";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
      <RequireAuth>
      <RoleProvider>
        <SimulationProvider>
          <AVRDrawerProvider>
            <AskNiqProvider>
            <BrowserRouter>
              <Routes>
                <Route element={<AppShell />}>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/mimic" element={<Mimic />} />
                  <Route path="/twins" element={<Twins />} />
                  <Route path="/twins/:twinId" element={<TwinDetail />} />
                  <Route path="/energy" element={<Energy />} />
                  <Route path="/yield" element={<YieldPage />} />
                  <Route path="/safety" element={<Safety />} />
                  <Route path="/thermal" element={<Navigate to="/safety" replace />} />
                  <Route path="/constraints" element={<Navigate to="/dashboard" replace />} />
                  <Route path="/carbon" element={<Carbon />} />
                  <Route path="/opportunities" element={<Opportunities />} />
                  <Route path="/actions" element={<Actions />} />
                  <Route path="/quality" element={<Quality />} />
                  <Route path="/simulation" element={<Simulation />} />
                  <Route path="/ontology" element={<Ontology />} />
                  <Route path="/tags" element={<Tags />} />
                  <Route path="/tags/:tagId" element={<TagDetail />} />
                  <Route path="/askniq" element={<AskNiqFullPage />} />
                </Route>
              </Routes>
            </BrowserRouter>
            <Toaster />
            </AskNiqProvider>
          </AVRDrawerProvider>
        </SimulationProvider>
      </RoleProvider>
      </RequireAuth>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
